import styled from '@emotion/styled'

export const LeftNavigationTile = styled.div<{ nestingLevel: number }>`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e1e3e7;
  padding-top: 6px;
  padding-left: ${props => props.nestingLevel * 20 + 5}px;
  padding-bottom: 6px;
`
